export enum SettingsType { Default, Combo, PropertyType }